// extracted by mini-css-extract-plugin
export default {"enter":"error-anim__enter___DKYpP","enterActive":"error-anim__enterActive___xkuo5","exit":"error-anim__exit____81Px","exitActive":"error-anim__exitActive___faC94"};